import {useSetContentApprovalMutation} from "@/api/campaignApi";
import AISparkIcon from "@/assets/colorable/ai_spark.svg?react";
import ConfirmationModal from "@/components/Common/ConfirmationModal";
import {useComposedCampaignState, useMiscActions} from "@/store/campaignForm";
import {setAiAutonomyModalAtom} from "@/store/jotaiAtoms";
import {useAtom} from "jotai";
import type {FC} from "react";
import {useTranslation} from "react-i18next";

const SetAiAutonomyModal: FC = () => {
  const {t} = useTranslation("content_approval");
  const [targetMode, setTargetMode] = useAtom(setAiAutonomyModalAtom);
  const campaignId = useComposedCampaignState(state => state.misc.id);
  const actions = useMiscActions();
  const {isPending, setContentApproval} = useSetContentApprovalMutation(Number(campaignId));

  if (!targetMode) {
    return null;
  }

  const toAiAutomated = targetMode === "ai_automated";

  return (
    <ConfirmationModal
      Icon={AISparkIcon}
      confirmButtonText={t(
        toAiAutomated ? "set_ai_autonomy_confirm_ai_automated" : "set_ai_autonomy_confirm_semi_automated",
      )}
      description={t(
        toAiAutomated ? "set_ai_autonomy_description_ai_automated" : "set_ai_autonomy_description_semi_automated",
      )}
      isPending={isPending}
      onClose={() => setTargetMode(null)}
      onConfirm={() =>
        setContentApproval(
          {mode: targetMode},
          {
            onSuccess: () => {
              actions.setMiscValue("contentApprovalMode", targetMode);
              setTargetMode(null);
            },
          },
        )
      }
      title={t(toAiAutomated ? "set_ai_autonomy_title_ai_automated" : "set_ai_autonomy_title_semi_automated")}
      tone={toAiAutomated ? "warning" : undefined}
    />
  );
};

export default SetAiAutonomyModal;
